import { CordovaPlugins } from '../../../shared/CordovaPlugins';
import { isIos, isNative } from '../../../shared/utils/is';
import { showErrorMessage } from '../../../shared/utils/notifications';
import { loadScript } from '../loadScript';
import { SUPPORT_CHAT_WIDGET_KEY, SUPPORT_CHAT_ZENDESK_VALUE, setLocalStorageWithExpiry } from './supportChatUtils';

export const initForethought = async () => {
    const user = $f.active_user;
    try {
        await loadScript('https://solve-widget.forethought.ai/embed.js', 'forethought-widget-embed-script', {
            'data-api-key': process.env.FORETHOUGHT_WIDGET_KEY,
            hidden: 'true',
            'hide-ft-after-zd': 'true',
            'position-x': 'left',
            'emit-tracking-events': 'true',
            'data-ft-Email': user.get('email'),
            'data-ft-Support-Product': 'chat_zenput'
        });
    } catch {
        return;
    }

    const isNativeIos = isIos() && isNative();

    window.addEventListener('message', (event) => {
        if (event.data.event === 'forethoughtWidgetClosed') {
            if (isNativeIos) {
                CordovaPlugins().Keyboard.disableScroll(true);
            }
            window.Forethought('widget', 'hide');
        }
        if (isNativeIos && event.data.event === 'forethoughtWidgetOpened') {
            CordovaPlugins().Keyboard.disableScroll(false);
        }

        if (event.data.event === 'forethoughtWidgetIntegrationHandoff') {
            window.Forethought('widget', 'close');
            setLocalStorageWithExpiry(
                SUPPORT_CHAT_WIDGET_KEY,
                SUPPORT_CHAT_ZENDESK_VALUE,
                parseInt(process.env.ZENDESK_TIMEOUT)
            );
        }
    });
};

export const isForethoughtAvailable = () => {
    // window.Forethought is Forethought's widget API, created by loadForeghought()
    return !!window.Forethought;
};

export const showForethoughtWidget = async () => {
    if (!window.Forethought) {
        showErrorMessage(_t('mobile_common_chat_unavailable'));
        return;
    }
    await window.Forethought('widget', 'show');
    await window.Forethought('widget', 'open');
};
